import React from 'react';
import Currency from '../currency';
import { RCTextInput, TextInputProps } from '@reverbdotcom/cadence/components';

interface Props extends TextInputProps {
  /** Currency for value */
  currencyCode: string;
}

const NUMERIC_PATTERN = '[0-9.,\\s]*';

export const MoneyInput = React.forwardRef<HTMLInputElement, Props>(
  ({ currencyCode, ...props }, ref) => {
    const symbol = Currency.get(currencyCode)?.symbol || '';

    return (
      <RCTextInput
        {...props}
        ref={ref}
        prefixText={symbol}
        type="text"
        pattern={NUMERIC_PATTERN}
        inputMode="decimal"
      />
    );
  },
);

MoneyInput.displayName = 'MoneyInput';
